import { Injectable } from '@angular/core';
import { ROLE } from 'app/models/role.model';
import { IUser } from '../../models';

@Injectable()
export class AuthenticationTokenStorageService {
  // Keep ordered
  private readonly authRoles: Array<ROLE> = [ROLE.ROOT, ROLE.ADMIN];
  private readonly loggedUserKey = 'die-cutting-Loggeduser';
  private readonly sessionStorage = window.sessionStorage;

  clean = (): void => {
    this.sessionStorage.removeItem(this.loggedUserKey);
    this.sessionStorage.clear();
  };

  save = (user: IUser): void => {
    this.sessionStorage.removeItem(this.loggedUserKey);
    this.sessionStorage.setItem(this.loggedUserKey, JSON.stringify(user));
  };

  getLoggedUser = (): IUser =>
    JSON.parse(this.sessionStorage.getItem(this.loggedUserKey) as string);

  getToken = (): string | undefined => this.getLoggedUser()?.token;

  hasRootRole = (): boolean =>
    this.getLoggedUser()?.roles?.includes(this.authRoles[0]) || false;

  hasAnyRole = (inputRoles: Array<string>): boolean =>
    inputRoles.some(
      (inputStrRole: string) => this.getLoggedUser()?.roles?.includes( inputStrRole as ROLE)
    ) || false;

  validateRoleNames = (names: Array<string>) =>
    names.every((roleToCheck) =>
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (<any>Object).values(ROLE).includes(roleToCheck)
    );
}
